exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[data-v-a2e819c6] {\n  padding-top: 1rem;\n}\ndiv td.comment[data-v-a2e819c6] {\n    white-space: pre-wrap;\n}\ndiv td button[data-v-a2e819c6] {\n    background: #CBDAF5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a2e819c6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/CommentList.vue
// module id = Z7yY
// module chunks = 1